import { AbsenceReason } from '../../../../shared/domain/user/Absence/Absence';

export const absenceReasonsTranslations = {
  [AbsenceReason.FELLOWSHIP]: 'Fellowship',
  [AbsenceReason.MATERNITY]: 'Maternité',
  [AbsenceReason.SICKNESS]: 'Maladie',
  [AbsenceReason.HOLIDAYS]: 'Vacances',
  [AbsenceReason.OTHER]: 'Autres'
};
